import AnnualDataQualityMeasurementIntegrity from "./AnnualDataQualityMeasurementIntegrity";

const AnnualBranchLocationPerformanceBenchmark = (props) => (
  <AnnualDataQualityMeasurementIntegrity
    {...props}
    title="Annual Branch/Location Performance Benchmark"
    description="Annual location benchmark envelope comparing branch demand, outcomes, wait/service percentiles, workload, and confidence."
    emptyTableText="No annual branch benchmark tables were supplied."
  />
);

export default AnnualBranchLocationPerformanceBenchmark;
